import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/shared/guards/auth.guard";
import { UmovmeEnvironmentDetailsComponent } from "./components/umovme-environment-details/umovme-environment-details.component";
import { UmovmeEnvironmentComponent } from "./components/umovme-environment.component";
const ɵ0 = {
    breadcrumb: "Ambientes Umov.me",
}, ɵ1 = {
    breadcrumb: "Cadastro/Edição Ambiente Umov.me",
};
const routes = [
    {
        path: "umovme-environment/list",
        component: UmovmeEnvironmentComponent,
        canActivate: [AuthGuard],
        data: ɵ0,
    },
    {
        path: "umovme-environment/details",
        component: UmovmeEnvironmentDetailsComponent,
        canActivate: [AuthGuard],
        data: ɵ1,
    },
];
export class UmovmeEnvironmentRoutingModule {
}
export { ɵ0, ɵ1 };
